(function() {

  var linkFunction = function($scope, element, attrs) {
    // console.log("SPC Header Link Func: ", $scope, element, attrs);
  }

  var controllerFunction = function($scope) {
    // console.log("SPC Header Controller Func: ", $scope);
  }

  var directiveFunction = function() {
    return {
      restrict: 'E',
      templateUrl: '../payments/app/components/spcHeader/spcHeader.template.html',
      controller: controllerFunction,
      link: linkFunction
    }
  }

  controllerFunction.$inject = ["$scope"];
  angular.module('cvsApp').directive('spcHeader', directiveFunction);

})();
